import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { TwcPopupOptions, TwcPopupRef, TwcPopupService } from '@topcon/twc-angular';

import { ImportWizardOptions } from '@mirage-projects/cw-commons';
import { ProjectType } from '@mirage-projects/cw-models';

import { CreateProjectDialogComponent } from '../components/create-project-dialog/create-project-dialog.component';
import { CreateWizardComponent } from '../components/create-wizard/create-wizard.component';

type openDialogOptions = { projectType?: ProjectType; options?: TwcPopupOptions };

@Injectable({ providedIn: 'root' })
export class CreateProjectService {
    openDialog$: Subject<openDialogOptions> = new Subject();
    openWizard$ = new Subject();

    refWizard: TwcPopupRef | undefined;

    constructor(private popupService: TwcPopupService) {}

    /**
     * Open the create project dialog by the selected project type
     * @param projectType Project type to create
     */
    openProjectDialog(projectType: ProjectType, options?: TwcPopupOptions): void {
        this.popupService.open(CreateProjectDialogComponent, options || {});
        this.openDialog$.next({ projectType, options });
    }

    /**
     * Open the import wizard by the selected import type
     * @param wizardOptions Options to select the import type
     */
    openWizard(wizardOptions: ImportWizardOptions = { importType: 'project' }, jobSiteId?: number): void {
        const options: TwcPopupOptions = {
            data: { ...wizardOptions, onRefresh$: wizardOptions.data?.onRefresh$ || null },
            params: { jobSiteId },
        };
        this.refWizard = this.popupService.open(CreateWizardComponent, options);
        this.openWizard$.next(null);
    }

    /**
     * Close the import wizard
     */
    closeWizard(): void {
        this.refWizard?.close();
    }
}
